import axios from "axios";
import { STRINGS_ENV } from "../config/stringsEnv";

const API_URL = `${STRINGS_ENV.apiUrl}user/orders`;

const authHeaders = (token) => {
  if (!token) {
    throw new Error("You must be logged in to manage orders.");
  }

  return { Authorization: `Bearer ${token}` };
};

const orderService = {
  getUserOrders: async (token) => {
    const res = await axios.get(API_URL, {
      headers: authHeaders(token),
    });
    return res.data;
  },
  createOrder: async (cartItems, total, token) => {
    const payload = {
      total,
      orderedDate: new Date(),
      status: "PENDING",
      products: cartItems.map((item) => ({
        sku: item.productSku,
        variant: item.variantName,
        name: item.productName,
        quantity: item.quantity,
        price: item.price,
        total: item.price * item.quantity,
        image: item.image
      })),
    };
    const res = await axios.post(API_URL, payload, {
      headers: authHeaders(token),
    });
    return res.data;
  },
  updateOrderDate: async (orderId, date, token) => {
    const res = await axios.put(
      `${API_URL}/${orderId}`,
      { date },
      { headers: authHeaders(token) }
    );
    return res.data;
  },
  cancelOrder: async (orderId, token) => {
    const res = await axios.delete(`${API_URL}/${orderId}`, {
      headers: authHeaders(token),
    });
    return res.data;
  },
};

export default orderService;
